import React, { useEffect, useState } from 'react';
import { StyleSheet } from 'react-native';
import { Button, Checkbox, Dialog, Text, TextInput } from 'react-native-paper';
import { colors, sizes } from 'shared/styles';

export interface RejectWorkoutResultConfirmPayload {
  rejectedReason: string;
  sendInAppMessage: boolean;
}

interface Props {
  visible: boolean;
  onDismiss(): void;
  onConfirm(payload: RejectWorkoutResultConfirmPayload): void;
  loading?: boolean;
}

const RejectWorkoutResultModal: React.FC<Props> = ({
  visible,
  onDismiss,
  onConfirm,
  loading = false,
}) => {
  const [rejectedReason, setRejectedReason] = useState('');
  const [sendInAppMessage, setSendInAppMessage] = useState(false);

  useEffect(() => {
    if (visible) {
      setRejectedReason('');
      setSendInAppMessage(false);
    }
  }, [visible]);

  const handleConfirm = () => {
    const reason = rejectedReason.trim();
    if (!reason) return;
    onConfirm({ rejectedReason: reason, sendInAppMessage });
  };

  return (
    <Dialog style={styles.dialog} visible={visible} onDismiss={onDismiss}>
      <Dialog.Title>Confirm rejection</Dialog.Title>
      <Dialog.Content>
        <Text style={styles.intro}>
          This result will be unranked from the leaderboard. Please provide a
          reason that will be visible to the athlete.
        </Text>
        <TextInput
          mode="outlined"
          label="Reason for rejection"
          multiline
          numberOfLines={4}
          maxLength={500}
          value={rejectedReason}
          onChangeText={setRejectedReason}
          placeholder="Please provide a clear reason for rejecting this result."
          style={styles.reasonInput}
        />
        <Checkbox.Item
          label="Send in-app message to user"
          status={sendInAppMessage ? 'checked' : 'unchecked'}
          onPress={() => setSendInAppMessage(!sendInAppMessage)}
        />
      </Dialog.Content>
      <Dialog.Actions>
        <Button onPress={onDismiss}>Cancel</Button>
        <Button
          mode="contained"
          color={colors.destructiveColor}
          disabled={loading || rejectedReason.trim() === ''}
          loading={loading}
          onPress={handleConfirm}
        >
          Reject result
        </Button>
      </Dialog.Actions>
    </Dialog>
  );
};

const styles = StyleSheet.create({
  dialog: {
    maxWidth: 500,
    alignSelf: 'center',
  },
  intro: {
    marginBottom: sizes.spacing,
  },
  reasonInput: {
    minHeight: 100,
    marginBottom: sizes.spacing,
  },
});

export default RejectWorkoutResultModal;
